<div class="lp-my-product-codes-header">
  <div class="lp-my-product-codes-header__wrapper">
    <button
      tuiIconButton
      type="button"
      iconStart="@tui.chevron-left"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      [routerLink]="'/loyalty'"
    ></button>

    <div class="title">
      <h1>{{ title }}</h1>
    </div>
  </div>
</div>
